export function isSockItem(item) {
  const haystack = [item?.label, item?.details?.category, ...(item?.tags || [])].filter(Boolean).join(' ').toLowerCase();
  return /\bsocks?\b|\bhosiery\b|\bcompression socks?\b/.test(haystack);
}

export function sockPairsFromWardrobe(items = []) {
  return items.filter(isSockItem).reduce((total, item) => {
    const explicit = Number(item?.sockPairs);
    return total + (Number.isFinite(explicit) && explicit > 0 ? explicit : 1);
  }, 0);
}

export function laundryVitalityLabel({ sockPairs = 0, laundryCount = 0 } = {}) {
  if (sockPairs <= 0) return 'Sock drawer needs attention';
  if (laundryCount >= Math.max(1, Math.round(sockPairs * 0.5))) return 'Laundry is becoming the bottleneck';
  if (sockPairs <= 3) return 'Sock drawer is at the edge';
  return 'Laundry has breathing room';
}
